<template>
 <div id="app">
    <router-view v-wechat-title="$route.meta.title"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted:function(){
    console.log(process.env);
  }
}
</script>





// WEBPACK FOOTER //
// src/App.vue